import * as a from "react";
import { g as p } from "./Slot-B31yZlfB.js";
import { S as m, s as f, h, n as l, g as v, i as g, k as b } from "./hook-CZjW2buS.js";
import { j as n } from "./jsx-runtime-C5mzlN2N.js";
import { c as x } from "./index-DI5SPFK9.js";
import { c as u } from "./cn-dYga0KKN.js";
var y = class extends m {
  #e;
  #r = void 0;
  #t;
  #s;
  constructor(t, s) {
    super(), this.#e = t, this.setOptions(s), this.bindMethods(), this.#i();
  }
  bindMethods() {
    this.mutate = this.mutate.bind(this), this.reset = this.reset.bind(this);
  }
  setOptions(t) {
    const s = this.options;
    this.options = this.#e.defaultMutationOptions(t), f(this.options, s) || this.#e.getMutationCache().notify({
      type: "observerOptionsUpdated",
      mutation: this.#t,
      observer: this
    }), s?.mutationKey && this.options.mutationKey && h(s.mutationKey) !== h(this.options.mutationKey) ? this.reset() : this.#t?.state.status === "pending" && this.#t.setOptions(this.options);
  }
  onUnsubscribe() {
    this.hasListeners() || this.#t?.removeObserver(this);
  }
  onMutationUpdate(t) {
    this.#i(), this.#a(t);
  }
  getCurrentResult() {
    return this.#r;
  }
  reset() {
    this.#t?.removeObserver(this), this.#t = void 0, this.#i(), this.#a();
  }
  mutate(t, s) {
    return this.#s = s, this.#t?.removeObserver(this), this.#t = this.#e.getMutationCache().build(this.#e, this.options), this.#t.addObserver(this), this.#t.execute(t);
  }
  #i() {
    const t = this.#t?.state ?? p();
    this.#r = {
      ...t,
      isPending: t.status === "pending",
      isSuccess: t.status === "success",
      isError: t.status === "error",
      isIdle: t.status === "idle",
      mutate: this.mutate,
      reset: this.reset
    };
  }
  #a(t) {
    l.batch(() => {
      if (this.#s && this.hasListeners()) {
        const s = this.#r.variables, r = this.#r.context;
        t?.type === "success" ? (this.#s.onSuccess?.(t.data, s, r), this.#s.onSettled?.(t.data, null, s, r)) : t?.type === "error" && (this.#s.onError?.(t.error, s, r), this.#s.onSettled?.(
          void 0,
          t.error,
          s,
          r
        ));
      }
      this.listeners.forEach((s) => {
        s(this.#r);
      });
    });
  }
};
function R(t, s) {
  const r = v(s), [e] = a.useState(
    () => new y(
      r,
      t
    )
  );
  a.useEffect(() => {
    e.setOptions(t);
  }, [e, t]);
  const i = a.useSyncExternalStore(
    a.useCallback(
      (o) => e.subscribe(l.batchCalls(o)),
      [e]
    ),
    () => e.getCurrentResult(),
    () => e.getCurrentResult()
  ), c = a.useCallback(
    (o, d) => {
      e.mutate(o, d).catch(g);
    },
    [e]
  );
  if (i.error && b(e.options.throwOnError, [i.error]))
    throw i.error;
  return { ...i, mutate: c, mutateAsync: i.mutate };
}
const O = x(
  "relative w-full rounded-lg border px-4 py-3 text-sm grid has-[>svg]:grid-cols-[calc(var(--spacing)*4)_1fr] grid-cols-[0_1fr] has-[>svg]:gap-x-3 gap-y-0.5 items-start [&>svg]:size-4 [&>svg]:translate-y-0.5 [&>svg]:text-current",
  {
    variants: {
      variant: {
        default: "bg-card text-card-foreground",
        destructive: "text-destructive bg-card [&>svg]:text-current *:data-[slot=alert-description]:text-destructive/90"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function w({
  className: t,
  variant: s,
  ...r
}) {
  return /* @__PURE__ */ n.jsx(
    "div",
    {
      "data-slot": "alert",
      role: "alert",
      className: u(O({ variant: s }), t),
      ...r
    }
  );
}
function A({ className: t, ...s }) {
  return /* @__PURE__ */ n.jsx(
    "div",
    {
      "data-slot": "alert-title",
      className: u(
        "col-start-2 line-clamp-1 min-h-4 font-medium tracking-tight",
        t
      ),
      ...s
    }
  );
}
function K({
  className: t,
  ...s
}) {
  return /* @__PURE__ */ n.jsx(
    "div",
    {
      "data-slot": "alert-description",
      className: u(
        "text-muted-foreground col-start-2 grid justify-items-start gap-1 text-sm [&_p]:leading-relaxed",
        t
      ),
      ...s
    }
  );
}
export {
  w as A,
  A as a,
  K as b,
  R as u
};
//# sourceMappingURL=Alert-CWApD0CL.js.map
